import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId", "src", "size"];
import React from 'react';
import Avatar from '@atlaskit/avatar';
import { N0, N90 } from '@atlaskit/theme/colors';
import { TeamAvatarImage } from './teams-avatar-image';
import { isSquareIcon } from './utils';
export var ICON_BACKGROUND = "var(--ds-icon-inverse, ".concat(N0, ")");
export var ICON_COLOR = "var(--ds-icon-subtle, ".concat(N90, ")");
export default function TeamAvatar(_ref) {
  var testId = _ref.testId,
    src = _ref.src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    appearance: isSquareIcon(src) ? 'square' : 'circle'
  }, props, {
    size: size,
    src: src,
    testId: "".concat(testId, "-team-avatar")
  }), /*#__PURE__*/React.createElement(TeamAvatarImage, {
    src: src,
    size: size,
    testId: testId
  }));
}